import { render, staticRenderFns } from "./PetsForm.vue?vue&type=template&id=3ff89ef6&"
import script from "./PetsForm.vue?vue&type=script&lang=js&"
export * from "./PetsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports